export default "__VITE_ASSET__mPTE94PR__"